import { orderConstants } from '../actions/constants/orderConstants';

const initialState = {	
	isError: false,
	isUserOrdersLoaded: false,
	userorderData: [],
	isUserRecurringOrdersLoaded: false,
	userRecurringorderData: []
}


const orderData = (state = initialState, action: any) => {
	switch (action.type) {
		case orderConstants.OrderGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				isUserOrdersLoaded: false
			};
		case orderConstants.OrderGetByFilterSuccess:
			return {
				...state,
				status: action.payload.status,
				userorderData: action.payload.orders,
				isUserOrdersLoaded: true
			};
		case orderConstants.OrderGetByFilterFailure:
			return {
				...state,
				error: action.payload,
				isError: true,
				isUserOrdersLoaded: false
			};

		case orderConstants.OrderRecurringGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				isUserRecurringOrdersLoaded: false
			};
		case orderConstants.OrderRecurringGetByFilterSuccess:
			return {
				...state,
				status: action.payload.status,
				userRecurringorderData: action.payload.boldSubscriptions.subscriptions,
				isUserRecurringOrdersLoaded: true
			};
		case orderConstants.OrderRecurringGetByFilterFailure:
			return {
				...state,
				error: action.payload,
				isError: true,
				isUserRecurringOrdersLoaded: false
			};
		default:
			return state;
	}
};

export default orderData;
